import {Component} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ModalController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import moment from 'moment';
import {title} from 'process';
import SubscriptionArticles from 'src/smoothr-web-app-core/models/Subscription';
import {SubscriptionTransaction} from 'src/smoothr-web-app-core/models/SubscriptionTransactions';

@Component({
	selector: 'app-alert-info-modal',
	templateUrl: './alert-info-modal.component.html',
	styleUrls: ['./alert-info-modal.component.scss']
})
export class AlertInfoModalComponent {
	title: string;
	subtitle: string;
	submit: string;
	cancel: string;
	constructor(private modalCtrl: ModalController) {}

	static async show(
		modalCtrl: ModalController,
		title: string,
		subtitle: string,
		submit: string,
		cancel: string
	): Promise<boolean> {
		const modal = await modalCtrl.create({
			component: AlertInfoModalComponent,
			cssClass: 'short-info-modal auto-height',
			componentProps: {
				title,
				subtitle,
				submit,
				cancel
			},
			showBackdrop: true,
			backdropDismiss: true
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		return response.data;
	}
	dismiss() {
		this.modalCtrl.dismiss();
	}
	approve() {
		this.modalCtrl.dismiss(true);
	}
}
